import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { FeedStoreContext } from './FeedStoreContext';
import { createFeedStore } from './createFeedStore';

interface FeedStoreProviderProps {
  children: React.ReactNode;
  defaultTimeRange: DateTimeRange;
}

export const FeedStoreProvider = ({
  children,
  defaultTimeRange,
}: FeedStoreProviderProps) => {
  return (
    <FeedStoreContext.Provider
      createStore={() => {
        return createFeedStore(defaultTimeRange);
      }}
    >
      {children}
    </FeedStoreContext.Provider>
  );
};
